export default "__VITE_ASSET__UoOOvS_D__"